// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"802":"738f6204","819":"b76890cb"}[chunkId] + ".chunk.js";
};